import { API } from "@/lib/api";
import type {
  ContestAgreementDetail,
  ContestAgreementRead,
} from "@/types/contestAgreement";
import { APIService } from "./api";

const service = new APIService<ContestAgreementRead>(API.ContestAgreements);

export const ContestAgreementsService = {
  sendAll: (payrollId: string) =>
    service.post(
      {
        payroll_id: payrollId,
      },
      "send/all",
    ),

  confirm: (token: string) => {
    return service.post({}, "confirmation", { token });
  },

  sendLink: (id: string) => service.post({}, `send/${id}`),
};

export const fetchContestAgreementsList = service.getList;

export const fetchContestAgreementDetail = (
  id: string,
): Promise<ContestAgreementDetail> => service.get<ContestAgreementDetail>(id);
